import { setUserInteractionDataAttribute } from "@shared/constants";
import Image from "next/image";

export type BBBStyle = "blue" | "gray";

export default function BBB({
	style = "blue",
	className = "",
	height = 28,
	width = 133,
}: {
	style?: BBBStyle;
	className?: string;
	height?: number;
	width?: number;
}) {
	const bbbImageSrc =
		style === "blue"
			? "https://seal-chicago.bbb.org/seals/blue-seal-200-42-bbb-1000037486.png"
			: "https://seal-chicago.bbb.org/seals/darkgray-seal-200-42-whitetxt-bbb-1000037486.png";
	return (
		<a
			{...setUserInteractionDataAttribute("bbb-link_button")}
			href="https://www.bbb.org/us/il/chicago/profile/financial-services/billdoctor-org-0654-1000037486/#sealclick"
			target="_blank"
			rel="noopener nofollow"
		>
			<Image
				height={height}
				width={width}
				className={`border-none mx-auto w-auto ${className}`}
				src={bbbImageSrc}
				alt="BillDoctor.org BBB Business Review"
			/>
		</a>
	);
}
